"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APInlineButton = _interopRequireDefault(require("./APInlineButton"));
var _commonComponent = require("../../propTypes/commonComponent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DownloadAPButton = function DownloadAPButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], _extends({
    styleName: _commonComponent.styleNames.general,
    icon: "download"
  }, props));
};
DownloadAPButton.propTypes = {
  text: _propTypes["default"].string
};
DownloadAPButton.defaultProps = {
  text: 'Download'
};
var _default = exports["default"] = DownloadAPButton;